import { useQuery } from '@tanstack/react-query';
import { getTableRequest } from '@shared/utils';
import { getEmployees } from '@api/employees';
import { useMemo } from 'react';

export const useGetEmployees = (search: string, pageSize: number = 5) => {
  const request = useMemo(
    () => getTableRequest({ pagination: { pageSize }, search }),
    [search, pageSize],
  );

  const {
    data,
    isLoading: isEmployeesLoading,
    isFetching: isEmployeesFetching,
  } = useQuery({
    queryKey: ['employees-options', request],
    queryFn: () => getEmployees(request),
  });

  return {
    employeesOptions: data?.data ?? [],
    isEmployeesLoading,
    isEmployeesFetching,
  };
};
